import { render } from "./UniqueKeyMessageReviewPage.vue?vue&type=template&id=73e10698&scoped=true"
import script from "./UniqueKeyMessageReviewPage.vue?vue&type=script&lang=js"
export * from "./UniqueKeyMessageReviewPage.vue?vue&type=script&lang=js"

import "./UniqueKeyMessageReviewPage.vue?vue&type=style&index=0&id=73e10698&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e10698"]])

export default __exports__